import React from "react";
import { colors2 } from "oolib";
import { UI_CAPTION } from "oolib/dist/v2/components/Typo2";

import TagsInputSingle from "@/components/inputs/DynamicTagsInputs/TagsInputSingle";
import { ConfigForm_SectionWrapper } from "../../../WidgetMetricCard/ConfigForm/ConfigForm_SectionWrapper";
import { getTenantSettings } from "./settings";

/**
 * One input: the volunteer. Stored as { _id, display } — the tag the
 * assessment docs carry. On the Volunteer Dashboard this is overwritten at
 * render time with the volunteer being viewed (see VolunteerDashboard's
 * configTransform), so the value saved here is that report's placeholder.
 */
export const ChildProgressConfigForm = ({ props, updateProps }) => {
  const settings = getTenantSettings();
  const { volunteer } = props;

  if (!settings) {
    return (
      <UI_CAPTION style={{ color: colors2.grey60, display: "block" }}>
        This widget is not set up for this platform.
      </UI_CAPTION>
    );
  }

  const handleVolunteerChange = (_id, tagValue) => {
    const picked = tagValue?.data?.[0];
    updateProps(({ volunteer: _volunteer, ...rest }) =>
      picked ? { ...rest, volunteer: { _id: picked._id, display: picked.display } } : rest
    );
  };

  return (
    <ConfigForm_SectionWrapper icon="User" title="Volunteer">
      <TagsInputSingle
        id="volunteer"
        tagType={settings.volunteerTagType}
        value={volunteer ? { data: [volunteer] } : undefined}
        onChange={handleVolunteerChange}
      />
      <UI_CAPTION style={{ color: colors2.grey60, display: "block" }}>
        One chart per child under this volunteer. On the Volunteer Dashboard the volunteer being viewed is used instead.
      </UI_CAPTION>
    </ConfigForm_SectionWrapper>
  );
};
